module.exports = __webpack_public_path__ + "img/oil.b3833d5a.svg";